$(document).ready(function () {

    $(document).on("change", "#RandevuluIadeForm .ddl_sehir", function () {

        var seciliSehirOID = $(this).val();

        if (seciliSehirOID != undefined && seciliSehirOID != "") {

            GetDistrict(seciliSehirOID);
        }
        else {
            $('#district option:gt(0)').remove();
        }
    });

    $(document).on("change", "#RandevuluIadeForm .ddl_ilce", function () {

        var seciliIlceID = $(this).val();

        if (seciliIlceID != undefined && seciliIlceID != "") {

            GetQuarters(seciliIlceID);
        } else {

            $('#quarter option:gt(0)').remove();
        }
    });

    $(document).on("click", "#RandevuAra", function (e) {
        $form = $("#RandevuluIadeForm");

        var controller = $form.attr("data-controller");

        $.ajax({
            type: "GET",
            url: "/tr/p/" + controller + "/GetRandevuTarih",
            dataType: "json",
            data: $form.serialize(),
            success: function (dt) {
                if (dt.success === true) {

                    $("#dateBoxContainer").html("");
                    var html = "";
                    $.each(dt.data, function (index, date) {

                        var formattedDate = new Date(date).toLocaleDateString("tr-TR", {
                            day: "numeric",
                            month: "long",
                            year: "numeric"
                        });
                        html += 
                            '<div class="col-auto date-box" data-date="' + date + '">' + formattedDate + '</div>';
                        ;
                    });
                    $("#dateBoxContainer").html(html);
                    $('#RandevuluIadeForm').find('input,select, textarea').prop('disabled', true);
                    $("#continueButtonDiv").hide();
                    $("#dateArea").show();

                } else {
                    SwalGenerate("error", dt.message, "İşlem Başarısız", "Tekrar Dene");
                }
            },
            error: function () {
                SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
            }
        });
    });

    $(document).on("click", ".date-box", function () {
        var dateBoxes = document.querySelectorAll('.date-box');
        $.each(dateBoxes, function (index, box) {
            box.classList.remove('active');
        });
        this.classList.add('active');
    });

    $(document).on("click", "#RedirectToRetOrder", function (e) {
        e.preventDefault();

        var date = $(".date-box.active").attr("data-date");

        if (date == undefined ) {
            SwalGenerate("error", "Lütfen iadenin teslim alınacağı tarihi seçiniz", "İşlem Başarısız", "Tekrar Dene");
            return;
        }

        $form = $("#RandevuluIadeForm");

        $form.find("input:disabled, select:disabled, textarea:disabled").prop("disabled", false);

        var $dateInput = $('<input>').attr({
            type: 'hidden',
            name: 'ReturnDate',
            value: date
        });

        $form.append($dateInput);

        $form.submit();
    });

    $(document).on("submit", "form.RetOrderForm", function () {
        $form = $(this);

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            beforeSend: function () {
                GenerateLocalLoading($form, "show");
            },
            success: function (dt) {
                if (dt.Sonuc === true) {
                    $("#AlertResult").removeClass("alert-danger");
                    $("#AlertResult").removeClass("alert-error");

                    $form.hide();

                    $("#AlertResult").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);
                    $(".RetTypeHome").css("display", "inline-block");
                }
                else {
                    SwalGenerate("error", dt.IslemSonucAciklama, "İşlem Başarısız", "Tekrar Dene");
                }

                $('html, body').animate({
                    scrollTop: 0
                }, 500);

            },
            error: function () {
                SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
            },
            complete: function () {
                GenerateLocalLoading($form, "hide");
            }
        });

        return false;
    });

    $(document).on("change", ".CancelRow select.RetType", function () {
        var CurrencyCode = $("#CurrencyCode").val();
        var CName = $("#CName").val();

        if (CName == "MemberlessOrders") {
            url = "/tr/p/MemberlessOrders/RetMemberlessOrderType";
        } else {
            url = "/tr/p/Orders/RetOrderType";
        }

        var value = $(this).val();
        $selectedRetTypeThis = $(this);
        var returnProduct = $selectedRetTypeThis.parents(".CancelRow").hasClass("returnProduct");

        if (value == "0") {
            $selectedRetTypeThis.parents(".CancelRow").find(".RetReason").css("display", "none");
        } else if (value == "1" || value == "2" || value == "4") {
            $.ajax({
                type: "POST",
                url: url,
                data: "RetType=" + value,
                dataType: 'json',
                success: function (dta) {
                    dta.JsonRs = JSON.parse(dta.JsonRs);
                    $selectedRetTypeThis.parents(".CancelRow").find(".RetReason").html("");
                    for (var i = 0; i < dta.JsonRs.length; i++) {
                        $selectedRetTypeThis.parents(".CancelRow").find(".RetReason").append(new Option(dta.JsonRs[i].Text, dta.JsonRs[i].Value));
                    }
                    $selectedRetTypeThis.parents(".CancelRow").find(".RetReason").css("display", "block");

                },
                error: function () {
                    SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("Kapat"));
                }
            });
        }
        else if (value == "-1") {
            $selectedRetTypeThis.parents(".CancelRow").find(".RetReason").css("display", "none");
        }

        var slc = $(this);
        var oid = slc.attr("dataid");
        var ind = slc.attr("dataind");
        var kacitem = parseInt($(".CancelRow select.RetType").length);
        if (kacitem <= 0) return;
        var itemsay = 0;

        var iaTutar = parseFloat(calcIadeTutari());
        var siptutar = parseFloat($("#TotalRetOrderAmount").attr("dataAmount").replace(",", "."));

        if (value === "2" || value === "4") {
            itemsay = parseInt(itemsay) + 1;
            //iaTutar += parseFloat($('#urunAmount' + $(this).attr("dataid")).val().replace(",", "."));
            $selectedRetTypeThis.parents(".CancelRow").addClass("returnProduct");
        }
        else if (iaTutar > 0 && returnProduct == true) {
            //iaTutar -= parseFloat($('#urunAmount' + $(this).attr("dataid")).val().replace(",", "."));
            $selectedRetTypeThis.parents(".CancelRow").removeClass("returnProduct");
        }

        //if (kacitem === itemsay) {
        //    iaTutar = siptutar;
        //}
        if (itemsay > 0 && iaTutar > 0) {
            //$(".iadedivi").removeClass("d-none");
        }
        else if (itemsay == 0 && iaTutar == 0) {
            $(".iadedivi").addClass("d-none");
        }
        if (slc.val() === "1" || slc.val() === "3") { //değişim yapmak istiyorum
            $(".CancelRow select[name=\"RetItem[" + ind + "].DegisimStoklar\"]").removeClass("gizle");
        }
        else {
            $(".CancelRow select[name=\"RetItem[" + ind + "].DegisimStoklar\"]").addClass("gizle");
        }

        $("#RetTotalAmount").html((iaTutar).toFixed(2) + " " + CurrencyCode);
        $("#RetTotalAmountVal").val(iaTutar);
        $("#OrderAmountAfterRet").html((siptutar - iaTutar).toFixed(2) + " " + CurrencyCode);
    });

    function calcIadeTutari() {
        var totalRetVal = 0;

        $(".CancelItems .RetOrderItem.CancelRow").each(function () {
            var retTypeVal = $(this).find("select.RetType").val();

            if (retTypeVal == 2 || retTypeVal == 6) {
                totalRetVal += $(this).find("input[type='hidden']").first().val();
            }
        });

        return totalRetVal;
    }
});